<script setup>
import { ref, toRefs } from 'vue'
import mySwal from '@/src/javascripts/plugins/mySwal.js'
import { SendOutlined } from '@ant-design/icons-vue'
import BaseRadio from '@/src/vueComponent/BaseRadio.vue'
import BaseTextInput from '@/src/vueComponent/BaseTextInput.vue'
import BaseSelect from '@/src/vueComponent/BaseSelect.vue'
import BackButton from '@/src/vueComponent/BackButton.vue'

const props = defineProps({
  token: {
    type: String
  },
  customerInfo: {
    type: Object,
    default: () => {
      return {
        id: null,
        name: '',
        english_name: '',
        ubn: '',
        category: '',
        public_key: '',
        private_key: '',
        state: ''
      }
    }
  },
  jswSalesUser: {
    type: Array,
    default: () => []
  },
  categoryList: {
    type: Array,
    default: () => []
  }
})
const { token, customerInfo, jswSalesUser, categoryList } = toRefs(props)
const editCustomerInfo = ref(customerInfo.value)

const salesUser = jswSalesUser.value.map((user) => {
  return {
    value: user.id,
    label: user.name
  }
})

// 後端資料格式為 [['絞線', 'strand']]，使用解構賦值取出 label 與 value
const customerCategoryList = categoryList.value.map(([label, value]) => ({
  value,
  label
}))

const submitForm = () => {
  $.ajax({
    url: editCustomerInfo.value.id
      ? `/settings/customers/${editCustomerInfo.value.id}`
      : '/settings/customers',
    type: editCustomerInfo.value.id ? 'PATCH' : 'POST',
    dataType: 'json',
    headers: { 'X-CSRF-Token': token.value },
    authenticity_token: true,
    data: editCustomerInfo.value,
    success: async (response) => {
      if (response.state === 0) {
        window.location.replace('/settings/customers')
      }
    },
    error: async (error) => {
      console.log('error', error)
      if (error.responseJSON.state === -1) {
        await mySwal.error({
          title: error.responseJSON.message.join('<br />'),
          timer: 3000
        })

        if (error.responseJSON.redirect_to) {
          window.location.replace(error.responseJSON.redirect_to)
        }
      }
    }
  })
}
</script>
<template>
  <form @submit.prevent="submitForm" class="leave-need-confirm">
    <div class="mb-3">
      <p class="flex items-baseline gap-1 py-1 text-lg font-bold">
        <span>狀態</span>
        <span class="text-sm font-light text-red-400">*</span>
      </p>
      <div class="mb-4 flex gap-3">
        <BaseRadio
          :label="'啟用'"
          :name="'state'"
          :value="'enable'"
          v-model="editCustomerInfo.state"
          required
        />
        <BaseRadio
          :label="'停用'"
          :name="'state'"
          :value="'disable'"
          v-model="editCustomerInfo.state"
          required
        />
      </div>
      <div class="mb-6 grid grid-cols-4 gap-4 md:grid-cols-2">
        <BaseTextInput
          :label="'中文名稱'"
          :name="'name'"
          v-model="editCustomerInfo.name"
          :maxlength="20"
          required
        />
        <BaseTextInput
          :label="'英文名稱'"
          :name="'english_name'"
          v-model="editCustomerInfo.english_name"
          :maxlength="20"
        />
        <BaseTextInput
          :label="'統編'"
          :name="'ubn'"
          v-model="editCustomerInfo.ubn"
          :maxlength="8"
        />
        <BaseSelect
          :label="'類型'"
          :name="'category'"
          :optionList="customerCategoryList"
          :optionsSelected="editCustomerInfo.category"
          @select="editCustomerInfo.category = $event"
        />
        <BaseSelect
          :label="'擔當者'"
          :name="'responsible_person_id'"
          :optionList="salesUser"
          :required="editCustomerInfo.id !== null"
          :optionsSelected="editCustomerInfo.responsible_person_id"
          @select="editCustomerInfo.responsible_person_id = $event"
        />
      </div>
      <div v-if="editCustomerInfo.id" class="grid grid-cols-2 gap-4 md:grid-cols-1">
        <div class="mb-4">
          <div class="flex items-baseline gap-1 py-1">
            <span class="text-lg font-bold">公開金鑰</span>
            <span class="text-sm font-light text-red-400">*</span>
          </div>
          <textarea
            name="public_key"
            :value="editCustomerInfo.public_key"
            @change="editCustomerInfo.public_key = $event.target.value"
            class="w-full rounded-md border"
            cols="30"
            rows="10"
            required
          ></textarea>
        </div>
        <div class="mb-4">
          <div class="flex items-baseline gap-1 py-1">
            <span class="text-lg font-bold">私密金鑰</span>
            <span class="text-sm font-light text-red-400">*</span>
          </div>
          <textarea
            name="private_key"
            :value="editCustomerInfo.private_key"
            @change="editCustomerInfo.private_key = $event.target.value"
            class="w-full rounded-md border"
            cols="30"
            rows="10"
            required
          ></textarea>
        </div>
      </div>
    </div>
    <div class="flex items-center justify-end gap-3 py-3">
      <BackButton :hasForm="true" :returnPath="'/settings/customers'" />
      <button type="submit" class="btn btn-success text-xl text-white">
        <SendOutlined />
        送出
      </button>
    </div>
  </form>
</template>
